import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'WatchAds';

const WatchAdsApi: any = baseApi(endpoint);

export default WatchAdsApi;